<span
  class="sheet-grabber pointer-events-none absolute inset-0 bottom-auto z-[5] flex h-1 w-full items-start justify-center sm:hidden"
>
  <span class=" bg-alert-ondark-inactive mt-2 block h-1 w-10 rounded ring-1 ring-white/15 sm:hidden" />
</span>
